import Tree from './Tree';

export default Tree;


//////////////////
// WEBPACK FOOTER
// ./~/element-react/dist/npm/es6/src/tree/index.js
// module id = 460
// module chunks = 0